@let trailing = trailingButton();
@let actions = inlineActions();
@let actionsPosition = inlineActionsPosition();
@let error = currentError();

<div
  class="text-field"
  [class.has-error]="hasError()"
  [class.is-disabled]="disabled()"
  [class.is-readonly]="readonly()">
  @if (label().length > 0) {
    <label class="label" [attr.for]="inputId()">
      <span>{{ label() }}</span>
      @if (labelTooltip().length > 0) {
        <fa-icon
          class="info"
          [icon]="faInfoCircle"
          [andorTooltip]="labelTooltip()"
          tooltipPosition="right"></fa-icon>
      }
    </label>
  }

  <div class="field-row">
    <div class="input-wrapper">
      @if (actions.length > 0 && actionsPosition === 'start') {
        <div class="inline-actions start">
          @for (action of actions; track $index) {
            @let state = inlineActionState($index);
            <button
              type="button"
              class="inline-action"
              [disabled]="action.disabled || disabled() || state === 'loading'"
              [attr.aria-label]="action.ariaLabel || action.label || null"
              [andorTooltip]="action.tooltip || ''"
              (click)="onInlineActionClick(action, $event, $index)">
              @switch (state) {
                @case ('loading') {
                  <fa-icon class="spin" [icon]="faSpinnerThird"></fa-icon>
                }
                @case ('success') {
                  <fa-icon class="success" [icon]="faCheck"></fa-icon>
                }
                @case ('error') {
                  <fa-icon class="error" [icon]="faXmark"></fa-icon>
                }
                @default {
                  @if (action.icon) {
                    <fa-icon [icon]="action.icon"></fa-icon>
                  } @else if (action.label) {
                    <span>{{ action.label }}</span>
                  }
                }
              }
            </button>
          }
        </div>
      }

      <input
        #inputEl
        [id]="inputId()"
        [type]="type()"
        [attr.autocomplete]="autocomplete()"
        [placeholder]="placeholder()"
        [value]="value()"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (keydown.enter)="onEnter()" />

      @if (actions.length > 0 && actionsPosition === 'end') {
        <div class="inline-actions end">
          @for (action of actions; track $index) {
            @let state = inlineActionState($index);
            <button
              type="button"
              class="inline-action"
              [disabled]="action.disabled || disabled() || state === 'loading'"
              [attr.aria-label]="action.ariaLabel || action.label || null"
              [andorTooltip]="action.tooltip || ''"
              (click)="onInlineActionClick(action, $event, $index)">
              @switch (state) {
                @case ('loading') {
                  <fa-icon class="spin" [icon]="faSpinnerThird"></fa-icon>
                }
                @case ('success') {
                  <fa-icon class="success" [icon]="faCheck"></fa-icon>
                }
                @case ('error') {
                  <fa-icon class="error" [icon]="faXmark"></fa-icon>
                }
                @default {
                  @if (action.icon) {
                    <fa-icon [icon]="action.icon"></fa-icon>
                  } @else if (action.label) {
                    <span>{{ action.label }}</span>
                  }
                }
              }
            </button>
          }
        </div>
      }
    </div>

    @if (trailing) {
      @let state = trailingState();
      <button
        type="button"
        class="trailing-button"
        [class.is-loading]="state === 'loading'"
        [class.is-success]="state === 'success'"
        [class.is-error]="state === 'error'"
        [disabled]="trailing.disabled || disabled() || state === 'loading'"
        [attr.aria-label]="trailing.ariaLabel || trailing.label || null"
        [andorTooltip]="trailing.tooltip || ''"
        (click)="onTrailingClick()">
        @switch (state) {
          @case ('loading') {
            <fa-icon class="spin" [icon]="faSpinnerThird"></fa-icon>
          }
          @case ('success') {
            <fa-icon [icon]="faCheck"></fa-icon>
          }
          @case ('error') {
            <fa-icon [icon]="faXmark"></fa-icon>
          }
          @default {
            @if (trailing.icon) {
              <fa-icon [icon]="trailing.icon"></fa-icon>
            }
            @if (trailing.label) {
              <span>{{ trailing.label }}</span>
            }
          }
        }
      </button>
    }
  </div>

  @let feedback = feedbackMessage();
  @if (feedback.length > 0) {
    <div
      class="feedback-message"
      [class.success]="trailingState() === 'success'"
      [class.error]="trailingState() === 'error'"
      [andorTextTicker]="feedback"
      role="status">
      <span class="ticker-text">{{ feedback }}</span>
    </div>
  } @else if (error.length > 0) {
    <div class="error-message" [andorTextTicker]="error" role="alert">
      <span class="ticker-text">{{ error }}</span>
    </div>
  } @else if (hint().length > 0) {
    <div class="hint-message" [andorTextTicker]="hint()">
      <span class="ticker-text">{{ hint() }}</span>
    </div>
  }
</div>
